import React from "react";
import { numberFormatters } from "common";
import "./unitCellRenderer.scss";
import { NumberFormatKind } from "common/types";
import { useWidgetCurrentDataScale } from "components/widgets/hooks/use-current-widget";
import { language } from "language/default";
export const UnitCellRenderer = (params) => {
    const currentDataScale = useWidgetCurrentDataScale(params.sectionId, params.widgetId);
    if (!params.value) {
        return React.createElement("span", null);
    }
    const { unit } = params.value;
    const val = params.value.value;
    if ((val || val === 0) && !isNaN(val) && unit) {
        if (unit !== language.en.widgets.unitOfAreaAbbreviations.other) {
            return React.createElement("span", { className: "unitCellRenderer" },
                numberFormatters(val, NumberFormatKind.compact, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, currentDataScale),
                " ",
                React.createElement("span", { className: "unit" }, unit));
        }
        return React.createElement("span", { className: "unitCellRenderer" }, numberFormatters(val, NumberFormatKind.default, { maximumFractionDigits: 2, minimumFractionDigits: 2 }, currentDataScale));
    }
    return React.createElement("span", null);
};
